/** @typedef {import('../../types/models').SettlementAccount} SettlementAccount */

import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { fetchSettlementAccounts } from '../../api';
import { handleQueryError } from '../../utils';

/** @returns {{ isLoading: boolean, accounts: SettlementAccount[], refetch: Function, userHasSettlementAccounts: boolean }} */
const useFetchSettlementAccounts = () => {
  const [accounts, setAccounts] = useState([]);

  const { isLoading, data, isError, error, refetch } = useQuery(
    'allAccounts',
    fetchSettlementAccounts
  );
  if (isError) {
    handleQueryError(error, 'settlement accounts');
  }
  useEffect(() => {
    if (data && data.data) {
      setAccounts(data.data);
    } else {
      setAccounts([]);
    }
  }, [data]);

  const userHasSettlementAccounts = Boolean(accounts.length);

  return { isLoading, accounts, refetch, userHasSettlementAccounts };
};

export { useFetchSettlementAccounts };
